export default {
  common_button_back: 'Nazaj',
  common_button_cancel: 'Prekliči',
  common_button_next: 'Naprej',
  common_button_no: 'Ne',
  common_button_ok: 'Potrdi',
  common_button_reset: 'Reset',
  common_button_skip: 'Preskoči',
  common_button_yes: 'Da',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: 'Vnesite svoj službeni e-poštni naslov',
  common_enterEmail_title: 'Vaš e-poštni naslov',
  common_error_message_cameraNotAllowed:
    'Če želite uporabiti to možnost, morate aplicikaciji dovoliti dostop do fotoaparata.',
  common_error_message_ForbiddenException: 'Nezadostne pravice',
  common_error_message_incorrectEmail: 'Vnesite veljaven e-poštni naslov',
  common_error_message_invalidCredentials: 'Ups. Napačno uporabniško ime in/ali geslo. Poskusite znova',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_missingField: 'Obvezno polje',
  common_error_message_noInternetConnection: 'Internetna povezava je bila prekinjena. Poskusite znova.',
  common_error_message_unauthorizedAccess: 'Nepooblaščen dostop',
  common_error_message_webServiceWrongConnection: 'Med prenosom podatkov je prišlo do napake. Poskusite znova',
  common_error_title: 'Napaka',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_placeholder_optional: 'Neobvezno',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: 'Če želite ustvariti nov kiosk, vzpostavite povezavo s spletno aplikacijo Proxyclick',
  common_setup_device_locked_content:
    'Kiosk je že v uporabi v drugem iPadu. Če boste kiosk uporabili na trenutnem iPadu, boste aplikacijo deaktivirali v drugem iPadu. Res želite nastaviti kiosk v tem iPadu?',
  common_setup_device_locked_continue_button: 'Nastavitev kioska',
  common_setup_device_locked_title: 'Kiosk je že v uporabi',
  common_setup_device_multiTenants: 'Več podjetij',
  common_setup_device_title: 'Izberite svoj kiosk',
  common_setup_loading_footer: 'Če želite prilagoditi kiosk, vzpostavite povezavo s spletno aplikacijo Proxyclick',
  common_setup_loading_message: 'Konfiguriranje ...',
  common_setup_loading_title: 'Postopek nastavitve kioska je v teku ...',
  common_setup_location_footer:
    'Če želite ustvariti novo lokacijo, vzpostavite povezavo s spletno aplikacijo Proxyclick',
  common_setup_location_kiosk: 'Aplikacija kiosk',
  common_setup_location_kiosks: 'kioski',
  common_setup_location_title: 'Izberi lokacijo',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: 'E-poštni naslov',
  common_setup_login_forgotPassword_button: 'Ste pozabili geslo?',
  common_setup_login_password: 'Geslo',
  common_setup_login_title: 'Prijava z računom Proxyclick',
  common_setup_ready_header: 'Želite nastaviti ta iPad kot kiosk za {0}?',
  common_setup_ready_message: 'Postopek nastavitve bo le kakšno minuto, nato bo kiosk pripravljen za uporabo',
  common_setup_ready_setup_button: 'Nastavitev',
  common_setup_ready_title: 'Pozdravljen/-a {0}',
  common_signup_company: 'Podjetje',
  common_signup_email: 'E-poštni naslov',
  common_signup_error_name: 'Vnesite ime in priimek',
  common_signup_loading_message1:
    'Aplikacijo Kiosk lahko nastavite tako, da jo povežete s spletno aplikacijo Proxyclick. E-pošto z vsemi podrobnostmi ste prejeli na svoj e-poštni naslov.',
  common_signup_loading_message2: 'Na spletnem mestu lahko nastavite tiskalnik za tiskanje priponk po prijavi.',
  common_signup_loading_message3: 'Prav tako lahko omogočite pošiljanje obvestil gostitelju ob prijavi obiskovalca.',
  common_signup_loading_message4:
    'Aplikacijo Kiosk lahko prilagodite po meri z izbiro barv in sliko na domačem zaslonu.',
  common_signup_loading_title: 'Ustvarjanje računa ...',
  common_signup_name: 'Ime',
  common_signup_name_placeholder: 'Ime Priimek',
  common_signup_password: 'Geslo',
  common_signup_title: 'Dobrodošli v Proxyclick',
  common_signup_tryFree_button: 'Pošlji',
  common_timeout_content: 'Dotik za prekinitev',
  common_timeout_title: 'Nazaj na domači zaslon',
  common_tooltip_disable_button: 'Onemogoči namige',
  common_tooltip_gotIt_button: 'Razumem',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} je bil obveščen, da ste dostavili paket',
  dm_delivery_confirmation_title: 'Hvala.',
  dm_delivery_confirmation_unknownRecipient:
    'Poslano je obvestilo, v katerem je podjetje {{Company_Name}} sporočilo, da ste jim dostavili paket',
  dm_delivery_recipient_name: 'Za koga je ta paket?',
  dm_delivery_recipient_unknown_button: 'Ne vem',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Vaša prijava je bila uspešna.',
  vm_checkin_confirmation_header_withPrint: 'Tiskanje priponke je v teku',
  vm_checkin_confirmation_message: 'Izvolite sesti, {{Host_FirstName}} bo z vami čez nekaj trenutkov',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Hvala.',
  vm_checkin_details_companyName: 'Podjetje',
  vm_checkin_details_email: 'E-poštni naslov',
  vm_checkin_details_firstname: 'Ime',
  vm_checkin_details_lastname: 'Priimek',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn: 'Pri zaključevanju prijave je prišlo do napake. Obrnite se na receptorja',
  vm_checkin_flow_company: 'Podjetje',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_flow_email: 'E-poštni naslov',
  vm_checkin_flow_error_message_imageNotAvailable: 'Ups, slika trenutno ni na voljo (težava z internetno povezavo)',
  vm_checkin_flow_licensePlate: 'Registrska številka',
  vm_checkin_flow_mobile: 'Vnesite svojo mobilno številko',
  vm_checkin_flow_mobile_info: 'S tem boste stopili v stik z vami v nujnih primerih, ko ste v objektu',
  vm_checkin_flow_tooltip_content:
    'Obiskovalcem lahko zastavite vprašanja, ki vam lahko pomagajo izboljšati izkušnjo ali povečati varnost prijave. Spremenite lahko zaporedje vprašanj glede na odgovore obiskovalcev. Prikazana vprašanja so vzročna vprašanja.',
  vm_checkin_flow_tooltip_title: 'Pametna vprašanja',
  vm_checkin_host_enterFullName: 'Vnesite ime in priimek gostitelja',
  vm_checkin_host_name: 'H komu ste namenjeni?',
  vm_checkin_host_notListed_block: 'Če ne poznate vašega gostitelja oz. ga ni na seznamu, povprašajte receptorja',
  vm_checkin_host_notListed_continue: 'Ni na seznamu',
  vm_checkin_host_tooltip_content:
    'Vnesite svoje ime in poslali vam bomo e-pošto s sporočilom, ki ga bodo vaši zaposleni prejeli ob prihodu obiskovalcev.',
  vm_checkin_host_tooltip_title: 'Obvestilo o prihodu obiskovalca',
  vm_checkin_host_unknown_button: 'Ne vem',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Strinjam se',
  vm_checkin_instructions_clearSignature_button: 'Počisti',
  vm_checkin_instructions_sendCopy_button: 'Polji kopijo sporočila po e-pošti',
  vm_checkin_instructions_sendCopyTo_button: 'Kopija bo poslana na naslov {0} (Spremeni)',
  vm_checkin_instructions_sign: 'Prosim podpišite se',
  vm_checkin_instructions_tooltip_content:
    'Obiskovalci lahko pogoje obiska potrdijo z dotikom ali podpisom. Pogoje lahko prilagodite glede na vrsto obiska. To možnost in kopico drugih možnosti lahko prilagajate v nadzorni plošči aplikacije Proxyclick.',
  vm_checkin_instructions_tooltip_title: 'Podpisano in zapečateno',
  vm_checkin_method_name: 'Pozdravljeni, nam zaupate svoje ime?',
  vm_checkin_method_name_enterFullName: 'Vnesite ime in priimek',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Vas ni na seznamu? Preverite pri receptorju',
  vm_checkin_method_name_notRegistered_continue: 'Vas ni na seznamu?',
  vm_checkin_method_tooltip_content:
    'Prijavite se kot "Justin Diaz" za ogled postopka prepoznave rednih ali predhodno registriranih obiskovalcev.',
  vm_checkin_method_tooltip_title: 'Prepoznavanje obiskovalca',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Fotografiraj',
  vm_checkin_picture_title: 'Nasmehnite se za zajem fotografije!',
  vm_checkin_picture_tooltip_content:
    'Aplikacijo Kiosk lahko prilagodite po meri in preprosto dodate ali odstranite možnosti, npr. fotografiranje obiskovalcev ali tiskanje priponk.',
  vm_checkin_picture_tooltip_title: 'Dodatne možnosti',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Potrditev prihoda',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Uredi podrobnosti',
  vm_checkin_summary_groupStats: '{0} od {1} oseb je že na obisku',
  vm_checkin_summary_meetingTime: 'Sestanek v {0}',
  vm_checkin_summary_reviewDetails_button: 'Pregled podrobnosti obiska',
  vm_checkin_summary_sendPass_button: 'Želim prejeti dostop za prihodnje obiske v pametni telefon',
  vm_checkin_summary_sendPassTo_button: 'Koda za stalni dostop bo poslana v {0} (Spremeni)',
  vm_checkin_summary_takeNewPicture_button: 'Nova fotografija',
  vm_checkin_summary_title: 'Vaš obisk v {{Company_Name}}',
  vm_checkin_summary_visiting: 'Na obisku v {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Dobrodošli, {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: 'Dobrodošli znova, {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Na svidenje, {{Visitor_FirstName}}.',
  vm_checkout_confirmation_message: 'Uspešno ste se odjavili. Upamo, da ste zadovoljni z obiskom.',
  vm_checkout_confirmation_title: 'Hvala za obisk.',
  vm_checkout_method_name: 'Vpišite svoje ime, če želite preveriti',
  vm_checkout_method_name_notFound: 'Ni mogoče najti',
  vm_checkout_method_title: 'Odjava',
  vm_identification_id_button: 'Optično branje ID-ja',
  vm_identification_qrCode_button: 'Optično branje povabila/kode',
  vm_infopack_confirmation: 'Hvala. \nVeč informacij smo vam poslali na {0}.',
  vm_infopack_email: 'Vnesite svoj e-poštni naslov, če želite več informacij o aplikaciji Proxyclick',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: 'Želim izvedeti več',
  vm_multiTenant_title: 'Dobrodošli, katero podjetje želite obiskati?',
  vm_product_footer_learnMore: 'Learn more',
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_qrCode_help: 'Pridržite kodo 10–15 cm pred kamero',
  vm_qrCode_not_recognized: 'Kode ni bilo mogoče prepoznati',
  vm_qrCode_title: 'Optično branje značke ali kode Passbook',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>NAVODILA ZA OBISKOVALCE IN SPORAZUM O ZAUPNOSTI</h1><p>Pozdravljeni, z velikim veseljem vas pozdravljamo kot gosta podjetja {{Company_Name}}.</p><h2>Zdravstvena in varnostna navodila</h2><p>Vaša varnost za celotno trajanje obiska je naša skrb, zato vas prosimo, da upoštevajte:</p><ul><li><b>Dostop do prostorov</b> je dovoljen samo v spremstvu uslužbenca podjetja {{Company_Name}}</li><li>Obiskovalci morajo celoten čas obiska nositi<b>priponko</b>, ki jo morajo ob odhodu vrniti receptorju</li><li>V primeru <b>izrednih razmer</b> morajo vsi obiskovalci nemudoma zapustiti prostore podjetja skozi najbližji zasilni izhod in se zglasiti na določenem zbirnem mestu</li><li>Obiskovalcem <b>ni dovoljeno fotografiranje</b> (slike ali videoposnetki) v prostorih podjetja ali v njegovi okolici</li><li><b>Kajenje v notranjih prostorih podjetja je strogo prepovedano</b></li></ul><h2>Dogovor o nerazkrivanju</h2><p>Med obiskom v prostorih podjetja {{Company_Name}} lahko kot obiskovalec pridobite zaupne informacije podjetja (vključno in brez omejitev, podatke o tehnologiji, postopkih, opremi, skicah ali tehničnih podatkih), ki običajno niso javnega značaja (v nadaljevanju: &#34;zaupni podatki&#34;).</p><p>Z odobritvijo vašega obiska prostorov podjetja {{Company_Name}} in s tem izkazanega zaupanja, se strinjate da ne boste </p><p>(a) razkrili ali kako drugače uporabili zaupnih podatkov podjetja, ki ste jih pridobili med obiskom ali pri naslednjih obiskih ali</p><p>(b) uporabili ali pomagali drugim pri uporabi in zlorabi zaupnih informacij.</p><p>(c) Uporabili kamer ali video pripomočkov za zajemanje in razkrivanje zaupnih informacij.</p><p>S prijavo v sistem ste seznanjeni in se strinjate z zdravstvenimi in varnostnimi navodili ter dogovorom o nerazkrivanju.</p>',
  vm_signup_defaultInstruction_name: 'Navodila morajo podpisati vsi obiskovalci',
  vm_signup_defaultInstruction_title: 'Preberite in podpišite spodaj',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Potrditev prihoda',
  vm_welcome_checkout_button: 'Odjava',
  vm_welcome_delivery_button: 'Dostava',
  vm_welcome_hello_line1: 'Pozdravljeni,',
  vm_welcome_hello_line2: 'v {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_title: 'Pozdravljeni v {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Če želite prilagoditi kiosk po meri, se priajvite v spletno aplikacijo Proxyclick. Poslali smo vam e-pošto z navodili. V spletno aplikacijo lahko prenesete svojo logotip, sliko za ozadje ter izberete barvo kioska, ki se sklada z identiteto vašega podjetja.',
  vm_welcome_tooltip_title: 'Prilagoditev po meri',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'ali',
};
